import React, { useMemo, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// Import the CaseView from NPM package
import { CaseView } from '@veritas/case-view'

// Keep existing hooks for now
import { useTicketByCaseId } from "../../hooks/useTicketByCaseId"
import { useCaseDetails } from "../../hooks/useCaseDetails"

// Import API classes
import PhysicianApi from "../../axios/physician/PhysicianApi"
import { hasPolicies } from "../../utils/decodeToken"
import CaseRegisterApi from "../../axios/case/CaseRegisterApi"
import CasesApi from "../../axios/case/CasesApi"
import PatientApi from "../../axios/patient/PatientApi"
import PrescriptionsApi from "../../axios/prescription/PrescriptionsApi"
import ChatRoomAPI from "../../axios/ChatRoomAPI"
import TicketAPI from "../../axios/TicketApi"
import TemplatesAPI from "../../axios/templates/TemplateAPI"
import CaseTagsAPI from "../../axios/CaseTagApi"
import LabsAPI from "../../axios/labs/LabsApi"
import APIHelper from "../../axios/apiHelper"
import PharmacyNoteConfigsAPI from "../../axios/pharmacyNoteConfigs/PharmacyNoteConfigsApi"

const CaseViewPage = ({
    physicianDetails,
    caseId,
    requestId,
}) => {
    const history = useHistory();
    const location = useLocation();

    const isOpenedFromOCP = new URLSearchParams(location.search).get('one-click-prescribe') === 'true';

    const handleNavigateBack = useCallback(() => {
        if (isOpenedFromOCP) window.close();
        else history.goBack();
    }, [isOpenedFromOCP, history]);

    // Create API classes object
    const apiClasses = useMemo(() => ({
        PhysicianAPI: PhysicianApi, // Fix case mismatch
        CaseRegisterApi,
        CasesApi,
        PatientApi,
        PrescriptionsAPI: PrescriptionsApi, // Fix case mismatch
        ChatRoomAPI,
        TicketAPI,
        TemplatesAPI,
        CaseTagsAPI,
        LabsAPI,
        APIHelper,
        PharmacyNoteConfigsAPI,
    }), []);

    const handleNavigateToCase = useMemo(() => (caseId, requestId, apiType) => {
        const path = `/dashboard/physician/caseview/${caseId}?requestId=${requestId || 'initial'}`;
        history.push(path);
    }, [history]);

    const canDeleteDocuments = hasPolicies(['deleteAdditionalDocuments']);

    return (
        <CaseView
            physicianDetails={physicianDetails}
            useTicketByCaseId={useTicketByCaseId}
            useCaseDetails={useCaseDetails}
            apiType="physician" // Use physician API endpoint
            apiClasses={apiClasses} // Pass API classes
            readOnlyMode={false} // Provider users can add charting and provider notes
            canDeleteDocuments={canDeleteDocuments}
            caseId={caseId}
            requestId={requestId}
            onNavigateToCase={handleNavigateToCase}
            onNavigateBack={handleNavigateBack}
        />
    )
}

export default CaseViewPage
